import { render, staticRenderFns } from "./UiTag.vue?vue&type=template&id=668f74b0"
import script from "./UiTag.vue?vue&type=script&lang=js"
export * from "./UiTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668f74b0')) {
      api.createRecord('668f74b0', component.options)
    } else {
      api.reload('668f74b0', component.options)
    }
    module.hot.accept("./UiTag.vue?vue&type=template&id=668f74b0", function () {
      api.rerender('668f74b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-tag/UiTag.vue"
export default component.exports